import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTime } from 'luxon'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { SxProps } from '@mui/material'

type Props = {
    label: string
    value?: DateTime | null
    onChange(value: DateTime | null | undefined): void
    minDate?: DateTime | null
    maxDate?: DateTime | null
    disabled?: boolean
    sx?: SxProps
}

const DatePicker = (props: Props) => {
    return (
        <LocalizationProvider
            dateAdapter={AdapterLuxon}
            adapterLocale={navigator.language}
        >
            <MUIDatePicker
                disabled={props.disabled}
                label={props.label}
                maxDate={props.maxDate || undefined}
                minDate={props.minDate || undefined}
                onChange={props.onChange}
                sx={{ backgroundColor: '#fff', ...props.sx }}
                value={props.value}
            />
        </LocalizationProvider>
    )
}

export default DatePicker
